import type { AxiosResponse } from 'axios';

import type { PaymentMethod } from '@/interfaces/user';

import request from '../request';

/**
 *
 * Retrieve a single payment method from Finorc
 */
export const getPaymentMethod = async ({
  paymentMethodId,
}: {
  paymentMethodId: string;
}): Promise<AxiosResponse<PaymentMethod>> => {
  const response = await request({
    method: 'GET',
    underdogAPIVersion: 'v1',
    url: `/user/payment_methods/${paymentMethodId}`,
    requiresLatLong: true,
  });

  return response;
};
